export default defineNuxtPlugin(() => {
  if (typeof window === 'undefined') return;

  const checkHorizontalScroll = () => {
    // Find all DataTable scroll wrappers
    const wrappers = document.querySelectorAll('[data-pc-section="wrapper"]');
    
    wrappers.forEach((wrapper) => {
      const hasScroll = wrapper.scrollWidth > wrapper.clientWidth;
      wrapper.classList.toggle('has-horizontal-scroll', hasScroll);
    });
  };

  // Run on load and resize
  window.addEventListener('resize', checkHorizontalScroll);
  
  // Use MutationObserver to detect when DataTables are added to the DOM
  const observer = new MutationObserver(() => {
    checkHorizontalScroll();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Initial check after a short delay to ensure tables are rendered
  setTimeout(checkHorizontalScroll, 100);
});
